import { render, staticRenderFns } from "./ExtraFieldInput.vue?vue&type=template&id=019d38fc&"
import script from "./ExtraFieldInput.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ExtraFieldInput.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports